const STORE_LINKS = {
  apple: 'https://apps.apple.com/us/app/grups/id6717571965',
  google: 'https://play.google.com/store/apps/details?id=ingenia.la.grupsapp',
  direct: 'http://get.grups.app/',
};

function StoreButtons({ className = '', imgClass = 'h-20' }) {
  return (
    <div className={`flex gap-4 justify-center items-center flex-wrap ${className}`}>
      <button
        className="bg-transparent border-none p-0 cursor-pointer rounded-lg overflow-hidden transition-transform duration-200 hover:-translate-y-0.5"
        onClick={() => window.open(STORE_LINKS.apple, '_blank')}
      >
        <img src="/assets/3.0/app-store-badge.svg" alt="Download on the App Store" className={`${imgClass} w-auto block`} />
      </button>
      <button
        className="bg-transparent border-none p-0 cursor-pointer rounded-lg overflow-hidden transition-transform duration-200 hover:-translate-y-0.5"
        onClick={() => window.open(STORE_LINKS.google, '_blank')}
      >
        <img src="/assets/3.0/google-play-badge.png" alt="Get it on Google Play" className={`${imgClass} w-auto block`} />
      </button>
    </div>
  );
}

function DownloadButton({ className = '', variant = 'light' }) {
  const base = 'h-14 rounded-lg px-5 border-none font-semibold text-[23px] font-poppins cursor-pointer shadow-[0_10px_24px_rgba(0,0,0,0.22)] block mx-auto w-full max-w-[400px]';
  const variants = {
    light: 'bg-[#F1F7FE] text-[#11497B]',
    red: 'bg-[#F1F7FE] text-[#9D1B1A]',
  };
  return (
    <button
      className={`${base} ${variants[variant]} ${className}`}
      onClick={() => window.open(STORE_LINKS.direct, '_blank')}
    >
      Descargá la app
    </button>
  );
}

/* ═══════════════════════════════════════════════
   SECTION 1 — HERO
   ═══════════════════════════════════════════════ */
function Hero() {
  return (
    <section className="relative bg-[#0f6aae] overflow-hidden text-[#E3E3E3]">
      <img className="absolute inset-0 w-full h-full object-cover z-0" src="/assets/5.0/FONDO_SEC1.svg" alt="" aria-hidden="true" />

      {/* ── MOBILE hero ── */}
      <div className="relative z-10 md:hidden px-[clamp(20px,5vw,40px)] pt-[clamp(32px,7vw,50px)] pb-8 text-center"
        style={{ paddingLeft: `calc(clamp(10px,3vw,20px) + clamp(6px,4vw,22px))`, paddingRight: 'clamp(10px,3vw,20px)' }}
      >
        <div className="max-w-[min(560px,95vw)] mx-auto flex flex-col items-stretch gap-4 w-full text-left">
          {/* Title */}
          <img className="w-[min(76vw,290px)] max-w-full h-auto self-start" src="/assets/5.0/TITULO%20SEC1.svg" alt="TU CONEXIÓN REAL EN LA FACU" />

          {/* Split: copy left + phone right */}
          <div className="grid items-start justify-start"
            style={{ gridTemplateColumns: '1.2fr 0.8fr', gridTemplateAreas: '"top top" "side phone" "bubble phone"', gap: 'clamp(8px,2vw,16px)' }}
          >
            {/* Copy top (spans both cols) */}
            <div className="justify-self-start self-start w-[clamp(200px,62vw,240px)] max-w-full my-[clamp(10px,2.5vw,20px)]" style={{ gridArea: 'top' }}>
              <img className="w-full h-auto block" src="/assets/5.0/noessolocursar_mobile.svg" alt="No es sólo cursar." />
            </div>

            {/* Copy side */}
            <div className="justify-self-start self-start w-[clamp(100px,31vw,120px)] max-w-full mt-[clamp(6px,2vw,12px)] flex flex-col gap-2.5" style={{ gridArea: 'side' }}>
              <img className="w-full h-auto block" src="/assets/5.0/actividadesbeneficios_mobile.svg" alt="Actividades, beneficios, descuentos y experiencias para estudiantes UB." />
              <img className="w-[110px] h-auto mt-1.5" src="/assets/5.0/registratecontumailub.svg" alt="Registrate con tu mail UB" />
            </div>

            {/* Phone */}
            <div className="relative ml-auto self-start w-[min(34vw,140px)] max-w-full mt-3" style={{ gridArea: 'phone' }}>
              <img className="relative z-[2] w-full h-auto block pointer-events-none" src="/assets/3.0/smartphone_mock.svg" alt="Smartphone" />
              <video className="absolute left-[7%] top-[3%] w-[84%] h-[93%] object-cover rounded-[25px] z-[1] block" src="/assets/5.0/video_instructivo_v5.mp4" autoPlay muted loop playsInline />
            </div>
          </div>

          {/* CTA */}
          <DownloadButton className="mt-7" />

          {/* Ribbon */}
          <div className="flex items-center justify-center mt-[18px] max-w-full w-full px-2.5">
            <img className="h-auto w-[min(72vw,260px)] max-w-[90vw] object-contain" src="/assets/5.0/anotate_primer_evento.svg" alt="¡¡ Y ANOTATE EN TU PRIMER EVENTO !!" />
          </div>
        </div>
      </div>

      {/* ── DESKTOP hero ── */}
      <div className="relative z-10 hidden md:block px-6 pt-[34px] pb-[120px]">
        <div className="max-w-[1200px] mx-auto grid grid-cols-[1.25fr_0.75fr] gap-6 items-start">
          {/* Left */}
          <div className="text-left">
            <div className="flex items-center gap-7 mt-2.5 mb-[18px]">
              <img className="w-[680px] h-auto block" src="/assets/5.0/TITULO%20SEC1.svg" alt="TU CONEXIÓN REAL EN LA FACU" />
            </div>
            <div className="mt-2.5 mb-7 max-w-[640px] flex flex-col gap-[26px]">
              <img className="w-[min(100%,560px)] h-auto block" src="/assets/5.0/noessolocursar_desktop.svg" alt="No es sólo cursar." />
              <img className="w-[min(100%,640px)] h-auto block" src="/assets/5.0/actividadesbeneficios_desktop.svg" alt="Actividades, beneficios, descuentos y experiencias." />
            </div>
          </div>

          {/* Right — phone */}
          <div className="flex justify-end">
            <div className="relative w-[260px]" style={{ transform: 'translate(6px, 6px)' }}>
              <img className="relative z-[2] w-full h-auto block pointer-events-none" src="/assets/3.0/smartphone_mock.svg" alt="Smartphone" />
              <video className="absolute left-[7%] top-[3%] w-[84%] h-[93%] object-cover rounded-[55px] z-[1] block" src="/assets/5.0/video_instructivo_v5.mp4" autoPlay muted loop playsInline />
              <img className="absolute z-[3] h-auto" style={{ left: '-70%', top: '40%', width: '175px' }} src="/assets/5.0/registratecontumailub.svg" alt="Registrate con tu mail UB" />
            </div>
          </div>
        </div>

        {/* CTA stack */}
        <div className="relative max-w-[1200px] mx-auto">
          <div className="flex justify-center my-7">
            <StoreButtons />
          </div>
          <div className="flex justify-center mt-5">
            <div className="flex items-center mt-[18px]">
              <img className="h-[88px] w-auto" src="/assets/5.0/anotate_primer_evento.svg" alt="¡Y sumate a tu primer evento!" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════
   SECTION 2 — ¿QUÉ ES CLUB UB?
   ═══════════════════════════════════════════════ */
function About() {
  return (
    <section className="relative bg-[#9D1B1A] text-white overflow-hidden">
      <img className="absolute inset-0 w-full h-full object-cover z-0 md:object-[center_-120px]" src="/assets/5.0/FONDO_SECCION_2_DESKTOP.svg" alt="" aria-hidden="true" />
      {/* Mobile: use mobile bg */}
      <img className="md:hidden absolute inset-0 w-full h-full object-cover z-0" src="/assets/5.0/FONDO_SECCIÓN_2.svg" alt="" aria-hidden="true" />

      {/* ── MOBILE ── */}
      <div className="relative z-[1] md:hidden px-6 py-[60px]">
        <div className="max-w-[320px] mx-auto flex flex-col items-start">
          <img className="w-[60vw] max-w-[260px] h-auto mb-5" src="/assets/3.0/que_es_club_ub.svg" alt="¿Qué es Club UB?" />

          <img className="w-[270px] max-w-full h-auto mt-2 mb-4" src="/assets/5.0/clubub_descripcion.svg" alt="Club UB es el espacio donde la Universidad de Belgrano y Grups conectan a los estudiantes con la vida universitaria real." />

          <img className="w-[112px] h-auto mt-3 mb-2" src="/assets/5.0/un_lugar_para.svg" alt="Un lugar para:" />
          <img className="w-[216px] max-w-full h-auto mb-[20px] pl-4" src="/assets/5.0/conocer_sumarte_acceder.svg" alt="Conocer gente de toda la facu, Sumarte a actividades sociales y deportivas, Acceder a beneficios exclusivos" />

          {/* Phone image */}
          <img className="block w-[min(90vw,720px)] max-w-none h-auto mx-auto my-5" src="/assets/5.0/imagenqueesclububMobile.png" alt="Vista de la app" />

          <DownloadButton variant="red" className="mt-4 text-[23px] text-[#9D1B1A] w-[min(100%,500px)]" />

          {/* Logos */}
          <div className="flex justify-center items-center gap-[18px] mt-[30px] mx-auto max-w-full w-full">
            <img src="/assets/3.0/LogoUB.svg" alt="UB" className="h-auto w-auto flex-1 max-w-[calc((100%-36px)/3)] max-h-[clamp(40px,12vw,100px)] min-w-0 object-contain" />
            <img src="/assets/3.0/loggrups.svg" alt="GRUPS" className="h-auto w-auto flex-1 max-w-[calc((100%-36px)/3)] max-h-[clamp(40px,12vw,100px)] min-w-0 object-contain" />
            <img src="/assets/3.0/LogoCLUB.svg" alt="CLUB" className="h-auto w-auto flex-1 max-w-[calc((100%-36px)/3)] max-h-[clamp(40px,12vw,100px)] min-w-0 object-contain" />
          </div>
        </div>
      </div>

      {/* ── DESKTOP ── */}
      <div className="relative z-[1] hidden md:block px-6 py-[70px]">
        <div className="max-w-[1200px] mx-auto">
          {/* Title */}
          <div className="flex justify-center mb-[60px]">
            <img className="w-[min(90vw,560px)] h-auto" src="/assets/3.0/que_es_club_ub.svg" alt="¿Qué es Club UB?" />
          </div>

          {/* Two columns */}
          <div className="grid grid-cols-[1.05fr_0.95fr] gap-10 items-start mx-auto max-w-[1200px]">
            {/* Left — Phone image */}
            <div className="flex flex-col items-center">
              <img className="block w-[min(100%,650px)] h-auto drop-shadow-[0_10px_20px_rgba(0,0,0,0.25)]" src="/assets/5.0/imagenqueesclubub.png" alt="Vista de la app en el celular" />
            </div>

            {/* Right — Text SVGs + logos */}
            <div className="flex flex-col items-start max-w-[550px]">
              <img className="w-[420px] max-w-full h-auto mb-[20px]" src="/assets/5.0/clubub_descripcion.svg" alt="Club UB es el espacio donde la Universidad de Belgrano y Grups conectan a los estudiantes con la vida universitaria real." />

              <img className="w-[175px] h-auto mt-4 mb-3" src="/assets/5.0/un_lugar_para.svg" alt="Un lugar para:" />
              <img className="w-[340px] max-w-full h-auto mb-[30px] pl-6" src="/assets/5.0/conocer_sumarte_acceder.svg" alt="Conocer gente de toda la facu, Sumarte a actividades sociales y deportivas, Acceder a beneficios exclusivos" />

              {/* Logos */}
              <div className="flex justify-center items-center gap-[50px] mt-[60px] mb-[18px] w-full max-w-[520px]">
                <img src="/assets/3.0/LogoUB.svg" alt="Universidad de Belgrano" className="h-[90px] w-auto" />
                <img src="/assets/3.0/loggrups.svg" alt="GRUPS" className="h-[45px] w-auto" />
                <img src="/assets/3.0/LogoCLUB.svg" alt="CLUB" className="h-[45px] w-auto" />
              </div>

              {/* Store buttons */}
              <div className="flex justify-center mt-6 w-full max-w-[520px]">
                <StoreButtons />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════
   SECTION 3 — EN 4 PASOS  (Mobile only)
   ═══════════════════════════════════════════════ */
function MobileSteps() {
  return (
    <section className="md:hidden relative bg-[#0F6AAE] text-[#E3E3E3] overflow-hidden px-4 py-[60px] text-center">
      <img className="absolute inset-0 w-full h-full object-cover z-0" src="/assets/5.0/FONDO_SECCIÓN_3M.svg" alt="" aria-hidden="true" />
      <div className="relative z-[1] max-w-[680px] mx-auto">
        {/* Title */}
        <img className="w-[85vw] max-w-[480px] h-auto mb-10" src="/assets/3.0/mobile_en4pasos.svg" alt="En 4 pasos, ya estás adentro" />

        {/* Steps */}
        <div className="relative flex justify-center">
          <ol className="list-none p-0 pr-3.5 mx-auto flex flex-col gap-4 w-full text-left font-semibold text-[clamp(14px,4.6vw,22px)]">
            <li className="flex items-start gap-[18px] ml-4 mt-5 mb-[35px]">
              <img className="h-[50px] w-auto relative top-1 left-2.5 mr-[25px] flex-shrink-0" src="/assets/3.0/dynamic_1.svg" alt="1" />
              <span className="block leading-tight">
                Descargá la app de Grups.
                <span className="inline-flex gap-2.5 ml-3 align-middle">
                  <img src="/assets/5.0/play%20store.svg" alt="" className="h-9 w-auto mt-1.5" />
                  <img src="/assets/5.0/app%20store.svg" alt="" className="h-9 w-auto mt-1.5" />
                </span>
              </span>
            </li>
            <li className="flex items-center gap-[18px] ml-4 mt-5 mb-[35px]">
              <img className="h-[50px] w-auto flex-shrink-0" src="/assets/3.0/dynamic_2.svg" alt="2" />
              <span className="block leading-tight">Ingresá con tu <strong>email UB</strong> y armá tu perfil.</span>
            </li>
            <li className="flex items-center gap-[18px] ml-4 mt-5 mb-[35px]">
              <img className="h-[50px] w-auto flex-shrink-0" src="/assets/3.0/dynamic_3.svg" alt="3" />
              <span className="block leading-tight">Elegí una actividad.</span>
            </li>
            <li className="flex items-center gap-[18px] ml-4 mt-5 mb-[35px]">
              <img className="h-[50px] w-auto flex-shrink-0" src="/assets/3.0/dynamic_4.svg" alt="4" />
              <span className="block leading-tight">¡Reservá tu lugar y <strong>listo!</strong></span>
            </li>
          </ol>
        </div>

        <DownloadButton className="mt-4" />

        {/* +1500 */}
        <img className="block w-[min(92vw,520px)] h-auto mx-auto mt-[60px]" src="/assets/5.0/+1500estudiantesmobile.svg" alt="+1500 estudiantes UB ya están adentro" />
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════
   SECTION 4 — COLLAGE (Mobile only)
   ═══════════════════════════════════════════════ */
function MobileCollage() {
  return (
    <section className="md:hidden relative bg-[#0F6AAE] text-[#E3E3E3] overflow-hidden px-4 py-[60px] text-center">
      <img className="absolute inset-0 w-full h-full object-cover z-0" src="/assets/5.0/FONDO_SECCIÓN_COLLAGE_M.svg" alt="" aria-hidden="true" />
      <div className="relative z-[1]">
        <img className="block w-[min(70vw,280px)] h-auto mx-auto mt-1.5 mb-5" src="/assets/5.0/conociendose_participando.svg" alt="Conociéndose y participando" />
        <img className="block w-[min(92vw,520px)] h-auto mx-auto rounded-[18px] my-10" src="/assets/5.0/COLLAGE_MOBILE.png" alt="Collage de actividades" />
        <img className="block w-[min(92vw,320px)] h-auto mx-auto my-10" src="/assets/3.0/parte_mobile.svg" alt="¿Qué estás esperando para ser parte?" />
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════
   SECTION 5 — FINAL CTA + FOOTER (Mobile only)
   ═══════════════════════════════════════════════ */
function MobileFooter() {
  return (
    <section className="md:hidden bg-gradient-to-b from-[#0F6AAE] to-[#062C48] text-[#E3E3E3] py-[30px] px-4 text-center">
      <DownloadButton variant="light" />
      <div className="font-poppins text-base font-semibold mt-[18px] mb-2.5 max-w-[320px] w-[90%] mx-auto text-center">
        Descargá la app ahora y unite al próximo evento
      </div>
      <a className="block w-max mx-auto my-1.5 text-[#E3E3E3] font-semibold text-base no-underline hover:underline" href="https://instagram.com/elclub.ub" target="_blank" rel="noreferrer">
        Seguinos en @elclub.ub
      </a>
      {/* Logos */}
      <div className="flex justify-center items-center gap-[18px] mt-3 mx-auto max-w-full w-full px-4">
        <img src="/assets/3.0/LogoUB.svg" alt="UB" className="h-auto w-auto flex-1 max-w-[calc((100%-36px)/3)] max-h-[clamp(40px,12vw,100px)] min-w-0 object-contain" />
        <img src="/assets/3.0/loggrups.svg" alt="GRUPS" className="h-auto w-auto flex-1 max-w-[calc((100%-36px)/3)] max-h-[clamp(40px,12vw,100px)] min-w-0 object-contain" />
        <img src="/assets/3.0/LogoCLUB.svg" alt="CLUB" className="h-auto w-auto flex-1 max-w-[calc((100%-36px)/3)] max-h-[clamp(40px,12vw,100px)] min-w-0 object-contain" />
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════
   DESKTOP SECTION 3-5 — UNIFIED: Steps + 1500 + Collage + Final
   (Single section with one background SVG on desktop)
   ═══════════════════════════════════════════════ */
function DesktopStepsToFooter() {
  return (
    <section className="hidden md:block relative bg-[#0F6AAE] text-[#E3E3E3] overflow-hidden px-6 pt-[70px] pb-[140px]" style={{ minHeight: '100vh' }}>
      <img className="absolute inset-0 w-full h-full object-cover object-top z-0" src="/assets/5.0/FONDO%20SECCION_3C_DESKTOP.svg" alt="" aria-hidden="true" />

      <div className="relative z-[1] max-w-[1200px] mx-auto">
        {/* Title */}
        <div className="flex justify-center mb-[26px]">
          <img className="w-[min(90vw,1000px)] h-auto block" src="/assets/3.0/en4pasos.svg" alt="En 4 pasos, ya estás adentro" />
        </div>

        {/* Steps */}
        <div className="relative flex justify-center">
          <ol className="list-none p-0 mx-auto flex flex-col gap-3 w-[min(95vw,1000px)] text-left font-semibold text-2xl">
            <li className="flex items-center gap-7 mt-[22px]">
              <img className="h-[54px] w-16 object-contain object-left flex-shrink-0" src="/assets/3.0/dynamic_1.svg" alt="1" />
              <span className="whitespace-nowrap">
                Descargá la app de Grups.
                <span className="inline-flex gap-3 ml-4 align-middle">
                  <img src="/assets/5.0/play%20store.svg" alt="" className="h-10 w-auto" />
                  <img src="/assets/5.0/app%20store.svg" alt="" className="h-10 w-auto" />
                </span>
              </span>
            </li>
            <li className="flex items-center gap-7 mt-[22px]">
              <img className="h-[54px] w-16 object-contain object-left flex-shrink-0" src="/assets/3.0/dynamic_2.svg" alt="2" />
              <span className="whitespace-nowrap">Ingresá con tu <strong>email UB</strong> y armá tu perfil.</span>
            </li>
            <li className="flex items-center gap-7 mt-[22px]">
              <img className="h-[54px] w-16 object-contain object-left flex-shrink-0" src="/assets/3.0/dynamic_3.svg" alt="3" />
              <span className="whitespace-nowrap">Elegí una actividad.</span>
            </li>
            <li className="flex items-center gap-7 mt-[22px]">
              <img className="h-[54px] w-16 object-contain object-left flex-shrink-0" src="/assets/3.0/dynamic_4.svg" alt="4" />
              <span className="whitespace-nowrap">¡Reservá tu lugar y <strong>listo!</strong></span>
            </li>
          </ol>
          {/* Floating "bajá la app" */}
          <img className="absolute right-[8%] top-[230px] w-[170px] h-auto" src="/assets/5.0/bajalaapp.svg" alt="Bajá la app" />
        </div>

        {/* Store buttons */}
        <div className="flex items-center justify-center gap-4 my-[30px]">
          <StoreButtons imgClass="h-16" />
        </div>

        {/* +1500 */}
        <img className="block w-[min(92vw,860px)] h-auto mx-auto mt-[60px] mb-[60px]" src="/assets/5.0/+1500estudiantesdesktop.svg" alt="+1500 estudiantes UB ya están adentro" />

        {/* Media block */}
        <div className="flex flex-col items-center gap-[40px] max-w-[1200px] mx-auto mt-[40px]">
          <img className="w-[min(70vw,520px)] h-auto block mt-10" src="/assets/5.0/conociendose_participando.svg" alt="Conociéndose y participando" />
          <img className="w-[min(92vw,900px)] h-auto block rounded-[26px] my-[30px]" src="/assets/5.0/COLLAGE_DESKTOP.png" alt="Collage de actividades" />
          <img className="w-[min(60vw,520px)] h-auto block mt-[30px]" src="/assets/5.0/queestasesperandodesktop.svg" alt="¿Qué estás esperando para ser parte?" />
        </div>

        {/* Final CTA + logos (inside same section for unified bg) */}
        <div className="text-[#E3E3E3] pt-[60px] pb-[90px] text-center mt-10">
          <div className="flex flex-col items-center gap-2.5 max-w-[1100px] mx-auto mt-[30px] mb-2.5">
            <StoreButtons />
            <div className="font-poppins text-xl font-semibold text-center mb-10">
              Descargá la app ahora y unite al próximo evento
            </div>
          </div>

          <a className="text-base block w-max mx-auto my-4 text-[#E3E3E3] font-light no-underline hover:underline mb-[70px]" href="https://instagram.com/elclub.ub" target="_blank" rel="noreferrer">
            Seguinos en @elclub.ub
          </a>

          <div className="flex justify-center items-center gap-8 mt-5 mx-auto">
            <img src="/assets/3.0/LogoUB.svg" alt="UB" className="h-[50px] w-auto" />
            <img src="/assets/3.0/loggrups.svg" alt="GRUPS" className="h-[50px] w-auto" />
            <img src="/assets/3.0/LogoCLUB.svg" alt="CLUB" className="h-[50px] w-auto" />
          </div>
        </div>
      </div>
    </section>
  );
}

/* ═══════════════════════════════════════════════
   MAIN APP
   ═══════════════════════════════════════════════ */
function App() {
  return (
    <main className="font-poppins overflow-hidden" role="main" aria-label="Somos Club UB">
      <Hero />
      <About />

      {/* Mobile: sections are separate with individual bg SVGs */}
      <MobileSteps />
      <MobileCollage />
      <MobileFooter />

      {/* Desktop: all in one section with unified bg SVG */}
      <DesktopStepsToFooter />
    </main>
  );
}

export default App;
